<template>
  <NodeEditor
    :node="value"
    @editFinish="$_savingOptionsMixin_onEditFinish"
    @delete="$_savingOptionsMixin_onDelete"
  >
    <EditChartHeader :value="value" />
    <div class="priority-matrix-chart-container">
      <svg ref="chart" class="pigeondoc-chart priority-matrix-chart"></svg>
    </div>
  </NodeEditor>
</template>

<script>
import EditChartHeader from '../ChartHeader/EditChartHeader.vue';
import NodeEditor from '../NodeEditor/NodeEditor.vue';

import priorityMatrixMixin from './priorityMatrixMixin.js';
import savingOptionsMixin from '../NodeEditor/Mixins/savingOptionsMixin.js';

export default {
  name: 'PriorityMatrix',
  mixins: [priorityMatrixMixin, savingOptionsMixin],
  components: {
    EditChartHeader,
    NodeEditor,
  },
};
</script>
